export default __webpack_public_path__ + "static/media/contact--desktop@2x.f50318c0.webp";